module.exports = __webpack_public_path__ + "img/Group 16174.b948ae50.svg";